
import React from 'react';
import { screenshots } from './screenshotsData';
import MobileScreenshotGallery from './MobileScreenshotGallery';
import TabletScreenshotCarousel from './TabletScreenshotCarousel';
import DesktopScreenshotCarousel from './DesktopScreenshotCarousel';

const ProductScreenshots: React.FC = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4">
      {/* Screenshots Gallery with responsive breakpoints */}
      <div className="relative">
        {/* Mobile: < 640px (sm) */}
        <MobileScreenshotGallery screenshots={screenshots} />
        
        {/* Tablet: 640px - 1024px (sm to lg) */}
        <TabletScreenshotCarousel screenshots={screenshots} />
        
        {/* Desktop: >= 1024px (lg+) */}
        <DesktopScreenshotCarousel screenshots={screenshots} />
      </div>
    </div>
  );
};

export default ProductScreenshots;
